<div class="fieldset" [ngClass]="context.findLatestDeclaration(DANGEROUS_GOODS)?.status === 'DECLARED'
                                          || isNotOwnDangerousGoodsDeclaration() && !appContext.isAdmin()
                                              ? 'disabled'
                                              : context.visitIsDeparted() ? 'enabled' : ''">


  <div class="row sticky-top bg-white" style="top:6.125rem">
    <div class="col-md-12">
      <app-alerting></app-alerting>
    </div>

    <div class="col-md-12">
      <app-action-nav-bar>
        <!--Buttons-->
        <div class="row mb-1">
          <div class="col text-end">
            @if (!context.isOrganisationNextDeclarant()) {
              @if (context.dangerousGoodsDeclaration?.completed) {
                <button data-bs-toggle="modal" data-bs-target="#cancelDGModal" id="cancelDG"
                        type="button" class="btn btn-secondary"
                        tabindex="-1">Cancel
                </button>
              }
            }
            @if (context.isOrganisationNextDeclarant()) {
              <button (click)="saveNextDangerousGoodsDeclaration()" type="button" class="btn btn-info" tabindex="-1">
                Save
              </button>
            }
            @if (!context.isOrganisationNextDeclarant()) {
              @if (!context.dangerousGoodsDeclaration?.completed) {
                <button (click)="save()" type="button"
                        class="btn btn-info" tabindex="-1">Save
                </button>
              }
              <button (click)="complete()" type="button" class="btn btn-info ms-1" tabindex="-1">Complete
              </button>
            }
          </div>
        </div>
      </app-action-nav-bar>
    </div>
  </div>

  @if (context.dangerousGoodsDeclaration) {
    <div #outerDiv (change)="onChange()">
      <!-- Stowage at arrival -->
      @if (!(context.isOrganisationNextDeclarant()) && showStowageAtArrival()) {
        <div class="row">
          <div class="col-12">
            <app-stowages [stowageArray]="context.dangerousGoodsDeclaration.dangerousGoods?.stowageAtArrival"
                          (upload)="upload($event)"></app-stowages>
          </div>
        </div>
      }
      <!-- Handlings -->
      <div class="row">
        <div class="declaration-block col-12">
          <h2>Handlings</h2>
        </div>
        <div class="col-12">
          <app-handlings></app-handlings>
        </div>
      </div>
    </div>
  }

  <div id="cancelDGModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Are you sure that you want to cancel this dangerous goods declaration?</h5>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
          <button type="button" class="btn btn-primary" (click)="cancel()" data-bs-dismiss="modal">Yes</button>
        </div>
      </div>
    </div>
  </div>

</div>
